import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { RestService } from '../services/rest.service';
import { Alert } from 'src/app/shared/alert/alert.class';
import { Router } from '@angular/router';
import { Title } from "@angular/platform-browser";

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})
export class SigninComponent implements OnInit {

  code: string;
  user: string;
  password: string;

  user_valid = true;
  password_valid = true;
  login_valid = true;
  email: string = "";


  alert = new Alert();

  @ViewChild('modal_forgot_pass') modal_update: ElementRef;

  constructor(private titleService: Title, private restService: RestService, private router: Router, private modalService: NgbModal,) {
    this.titleService.setTitle("CLARA | SignIn");
  }

  ngOnInit() {
    this.validate_token();
  }

  validate_token() {
    const token = this.restService.getToken();
    if (token) this.router.navigateByUrl('/');
  }

  user_login() {
    this.login_valid = true;
    this.user_valid = (this.user != null && this.user != '');
    this.password_valid = (this.password != null && this.password != '');

    if (this.user_valid && this.password_valid) {
      const user = { user: this.user, password: this.password };
      this.restService.user_login(user).subscribe(
        data => {
          if (data.success) {
            this.restService.setToken(data.token);
            const token = this.restService.getToken();
            if (token) this.router.navigateByUrl('/');
            else this.login_valid = false;
          } else {
            this.login_valid = false;
          }
        },
        error => {
          this.login_valid = false;
        });
    }
  }

  submit() {
    this.email = "";
    this.alert.set_success("Hemos enviado un mensaje a tu correo");
  }


  open_modal_forgot() {
    this.modalService.open(this.modal_update, { size: 'md' }).result.then((result) => {
      if (result == 'send') {
        this.submit();
      }
      this.email = ""
    }, (reason) => {
      this.email = "";
    });
  }

  async loginCognito() {
    this.login_valid = true;
    this.user_valid = (this.user != null && this.user != '');
    this.password_valid = (this.password != null && this.password != '');

    if (this.user_valid && this.password_valid) {
      const user = { user: this.user, password: this.password };
      this.restService.user_login(user).subscribe(
        data => {
          if (data.success) {
            this.restService.setToken(data.token);
            const token = this.restService.getToken();
            if (token) this.router.navigateByUrl('/');
            else this.login_valid = false;
          } else {
            this.login_valid = false;
          }
        },
        error => {
          this.login_valid = false;
        });

    }
  }


}
